import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.observeChanges();
  }

  observeChanges() {
    const observer = new MutationObserver(() => this.cleanup());
    observer.observe(this.menuTarget, { childList: true });
  }

  cleanup() {
    const noActivities = this.menuTarget.querySelector("#nav-no_activities");
    const activities = this.menuTarget.querySelectorAll("li:not(#nav-no_activities)");

    if (activities.length > 0 && noActivities) {
      noActivities.remove();
    }
  }
}
